export const SET_OTHER_CATEGORIES = 'SET_OTHER_CATEGORIES';

export const setOtherCategories = (otherCategories: any) => ({
  type: SET_OTHER_CATEGORIES,
  data: otherCategories,
});
